<div class="flex-direction-column align-center gap-15 container-balao-sugestao">
  <span class="font-24 weight-700">Você não pode trocar a sua senha</span>
  <span class="font-12 weight-400" style="text-align: center;">
    Você não pode alterar a sua senha pois a sua forma de autenticação no Claribot é por meio de AD (Active Directory),  conforme definido pelo administrador.
  </span>
  <span class="font-12 weight-400" style="text-align: center;">
    Para alterar a sua senha de acesso, entre em contato com o administrador do grupo.
  </span>
</div>
